@if(ready$()) {
    <quill-editor
    ngfQuillAccessibility
    format="html"
    [formControl]="control"
    [modules]="modules"
    [formats]="formats"
    [placeholder]="placeholder"
    (onEditorCreated)="onEditorCreated($event)"
    (onBlur)="onEditorBlur()" />

    @if(counter() !== null) {
        <div class="character-counter" [class.over-limit]="maxLength && counter() > maxLength">
            {{ counter() }} @if(maxLength) { / {{ maxLength }} } characters <mat-icon inline ngfTooltip="Formatting can effect character count">help</mat-icon>
        </div>
    }
}

